IntlMessageFormat.__addLocaleData({"locale":"mas","pluralRuleFunction":function (n,ord){if(ord)return"other";return n==1?"one":"other"}});
IntlMessageFormat.__addLocaleData({"locale":"mas-KE","parentLocale":"mas"});
IntlMessageFormat.__addLocaleData({"locale":"mas-TZ","parentLocale":"mas"});
